import script from "./AddCompanyContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCompanyContactModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCompanyContactModal.vue?vue&type=style&index=0&id=46eb2a0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46eb2a0e"]])

export default __exports__